import React from 'react';
import { useServicesChartsDataContext } from '../../hooks/useServicesChartsDataContext';
import useServicesPerMonthPerYearTotalChart from './hooks/useServicesPerMonthPerYearTotalChart';
import { SimpleBars } from '../../../Charts/SimpleBars';

export const ServicesPerMonthPerYearTotal = ({
    height = 400,
    isMoney = false
}) => {
    const { module } = useServicesChartsDataContext();
    const { series, months } = useServicesPerMonthPerYearTotalChart();

    return (
        <SimpleBars
            series={series}
            values={[]}
            subtitles={months}
            title={`Evolução ${module.sectionTitle} Mensal no Ano Selecionado`}
            isMoney={isMoney}
            showDataLabels={series.map((item) => item.name).length <= 1}
        />
    );
};
